<mat-accordion
	[multi]="true"
	displayMode="flat"
>
	<ng-container *ngFor="let pet of pets">
		<mat-expansion-panel class="pet-quote__panel mat-elevation-z0">
			<mat-expansion-panel-header class="pet-quote__heading">
				<mat-panel-title class="pet-quote__title">
					{{ pet.name }}
					<span
						#petInfoTip
						#popoverControl="popoverControl"
						class="pet-quote__title-icon"
						data-popover
					>
						<mat-icon color="accent">info</mat-icon>
					</span>
					<ng-template
						cdkConnectedOverlay
						[cdkConnectedOverlayOpen]="popoverControl.visible"
						[cdkConnectedOverlayOrigin]="petInfoTip"
					>
						<app-popover-tip>
							<div class="c-popover">
								<dl class="c-popover__details">
									<dt class="c-popover__details-key">Species</dt>
									<dd class="c-popover__details-value">{{ pet.species }}</dd>
								</dl>
								<dl class="c-popover__details">
									<dt class="c-popover__details-key">Breed</dt>
									<dd class="c-popover__details-value">{{ pet.breedName }}</dd>
								</dl>
								<dl class="c-popover__details">
									<dt class="c-popover__details-key">Gender</dt>
									<dd class="c-popover__details-value">{{ pet.gender }}</dd>
								</dl>
								<dl class="c-popover__details">
									<dt class="c-popover__details-key">Age</dt>
									<dd class="c-popover__details-value">{{ pet.ageInYears }}</dd>
								</dl>
							</div>
						</app-popover-tip>
					</ng-template>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<section class="pet-quote__detail">
				<p class="pet-quote__detail-heading">
					{{ pet.petCoverage?.insuranceTypeDisplayValue }} Coverage
				</p>
				<section
					aria-label="Insurance Premium Detail"
					class="pet-quote__detail-info"
				>
					<p class="pet-quote__detail-info-key">
						<strong>I:</strong>
						<span>
							{{ pet.petCoverage?.annualMaximumDisplayValue }} /
							{{ pet.petCoverage?.deductibleDisplayValue }} /
							{{ pet.petCoverage?.copayDisplayValue }}
						</span>
					</p>
					<p class="pet-quote__detail-info-value">
						{{ pet.petCoverage?.illnessPremium ?? 0 | currency }}
					</p>
				</section>
				<section
					aria-label="Exam Fees Detail"
					class="pet-quote__detail-info"
				>
					<p class="pet-quote__detail-info-key">
						<strong>Exam Fees:&nbsp;</strong>
						<span>{{ pet.petCoverage?.examFeeCoverageDisplayValue }}</span>
					</p>
				</section>
				<section
					aria-label="Prescription Drugs Detail"
					class="pet-quote__detail-info"
				>
					<p class="pet-quote__detail-info-key">
						<strong>Prescription Drugs:&nbsp;</strong>
						<span>{{ pet.petCoverage?.drugDentalDisplayValue }}</span>
					</p>
				</section>
				<section
					aria-label="Wellness Detail"
					class="pet-quote__detail-info"
				>
					<p class="pet-quote__detail-info-key">
						<strong>W:</strong>
						<span>
							{{ pet.petCoverage?.wellnessDisplayValue !== 'None' ? '$' : ''
							}}{{ pet.petCoverage?.wellnessDisplayValue }}
						</span>
					</p>
					<p class="pet-quote__detail-info-value">
						{{ pet.petCoverage?.wellnessPremium ?? 0 | currency }}
					</p>
				</section>
			</section>
		</mat-expansion-panel>
		<section class="pet-quote__summary">
			<div class="pet-quote__summary-label">
				<p class="pet-quote__summary-label-key">
					<span>Insurance</span>
					<span *ngIf="pet.petCoverage?.wellnessDisplayValue !== 'None'">+ Wellness</span>
				</p>
				<p class="pet-quote__summary-label-sub">(with discounts)</p>
			</div>
			<p class="pet-quote__summary-amount">{{ pet.petCoverage?.totalPremium | currency }}</p>
		</section>
	</ng-container>
</mat-accordion>
